import React from 'react'
import {Route} from 'react-router'
import {logoutUser} from 'redux/modules/currentUser/actions'

import AuthView, {SignIn, SignUp, ForgotForm, SetPasswordForm} from 'views/AuthView'

const logout = ({dispatch}) => (nextState, replace, callback) => {
  const redirect = () => {
    replace({pathname: '/login'})
    callback()
  }

  dispatch(logoutUser())
    .success(redirect)
    .fail(redirect)
}

export default (store, checkToken) => {
  return (
    <Route component={AuthView}>
      <Route
        path='login'
        title='Sign in'
        bg='invert'
        component={SignIn} />
      <Route
        path='register'
        title='Sign up'
        bg='normal'
        component={SignUp}
      />
      <Route
        path='forgot'
        title='Forgot password'
        bg='normal'
        component={ForgotForm}
      />
      <Route path='reset' title='Reset password' component={SetPasswordForm} onEnter={checkToken(store)} />
      <Route path='verify' title='Set password' component={SetPasswordForm} />
      <Route path='logout' onEnter={logout(store)} />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/auth.js